import * as types from './mutation-types';

const mutations = {
  [types.MARK_ANNOUNCEMENT_AS_READ](state, announcement) {
    announcement.wasRead = true;
  },

  [types.UPDATE_ANNOUNCEMENTS_LIST](state, unreadAnnouncements) {
    state.unreadAnnouncements = unreadAnnouncements;
  },
};

export default mutations;
